/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Share_Card_Top_LiftsInputs */

const en_us2_workout_share_card_top_lifts = /** @type {(inputs: Workout_Share_Card_Top_LiftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best sets`)
};

const pt_br2_workout_share_card_top_lifts = /** @type {(inputs: Workout_Share_Card_Top_LiftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhores séries`)
};

const es_419_workout_share_card_top_lifts = /** @type {(inputs: Workout_Share_Card_Top_LiftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejores series`)
};

const pt_pt2_workout_share_card_top_lifts = /** @type {(inputs: Workout_Share_Card_Top_LiftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhores séries`)
};

const fr_fr2_workout_share_card_top_lifts = /** @type {(inputs: Workout_Share_Card_Top_LiftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilleures séries`)
};

const de_de2_workout_share_card_top_lifts = /** @type {(inputs: Workout_Share_Card_Top_LiftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beste Sätze`)
};

const it_it2_workout_share_card_top_lifts = /** @type {(inputs: Workout_Share_Card_Top_LiftsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie migliori`)
};

/**
* | output |
* | --- |
* | "Best sets" |
*
* @param {Workout_Share_Card_Top_LiftsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_share_card_top_lifts = /** @type {((inputs?: Workout_Share_Card_Top_LiftsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Share_Card_Top_LiftsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_share_card_top_lifts(inputs)
	if (locale === "es-419") return es_419_workout_share_card_top_lifts(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_share_card_top_lifts(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_share_card_top_lifts(inputs)
	if (locale === "de-DE") return de_de2_workout_share_card_top_lifts(inputs)
	if (locale === "it-IT") return it_it2_workout_share_card_top_lifts(inputs)
	return en_us2_workout_share_card_top_lifts(inputs)
});
export { workout_share_card_top_lifts as "workout-share.card_top_lifts" }